import get from 'lodash/get';
import fetchProfileIfInQuery from 'src/common/actions/connectors/fetchProfileIfInQuery';
import connectAsync from '../../utils/connectAsync';
import { getPaymentCompletionPageItems } from '../../actions/paymentCompletion';
import { PAYMENT_COMPLETION_KEY } from '../../constants/payment/paymentCompletion';
import PaymentCompletionRoute from './PaymentCompletionRoute';

function fetchCompletionPageItems({ store }) {
  const config = get(store.getState(), 'config.autoupdate');
  const paymentCompletionCategory = get(config, PAYMENT_COMPLETION_KEY, '');
  return getPaymentCompletionPageItems(paymentCompletionCategory);
}

export default connectAsync([fetchCompletionPageItems, fetchProfileIfInQuery])(
  PaymentCompletionRoute,
);
